import { render, staticRenderFns } from "./PscImageComponent.vue?vue&type=template&id=1dcb4e96&scoped=true&"
import script from "./PscImageComponent.vue?vue&type=script&lang=js&"
export * from "./PscImageComponent.vue?vue&type=script&lang=js&"
import style0 from "./PscImageComponent.vue?vue&type=style&index=0&id=1dcb4e96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcb4e96",
  null
  
)

export default component.exports